function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
}
function getCookie(name) {
  return document.cookie.split('; ').reduce((r, v) => {
    const parts = v.split('=');
    return parts[0] === name ? decodeURIComponent(parts[1]) : r
  }, '');
}
function deleteCookie(name) {
  document.cookie = name + '=; Max-Age=0; path=/';
}
function customProductRedirection(tab, varName, hairLength) {
  // setCookie('tabName', tab, 1);
  setCookie('variantName', varName, 1);
  setCookie('hairLength', hairLength, 1);
  window.location.href = "/products/hair-extensions";
}

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    function scrollSwatchIntoView(selector) {
      const swatchEl = document.querySelector(selector);

      if (swatchEl) {
        const container = swatchEl.closest(".variant-picker__option-values");

        console.log("Selector:", selector);
        console.log("Swatch:", swatchEl);
        console.log("Container:", container);

        try {
          // ✅ Preferred method
          swatchEl.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center"
          });
        } catch (e) {
          // 🔄 Fallback method
          if (container) {
            const swatchLeft = swatchEl.offsetLeft;
            const swatchWidth = swatchEl.offsetWidth;
            const containerWidth = container.offsetWidth;

            container.scrollTo({
              left: swatchLeft - (containerWidth / 2) + (swatchWidth / 2),
              behavior: "smooth"
            });
          }
        }
        return true; // found & scrolled
      }
      return false; // not found yet
    }

    // Retry wrapper
    function waitAndScroll(selector, maxRetries = 5, interval = 300) {
      let attempts = 0;
      function tryScroll() {
        if (!scrollSwatchIntoView(selector) && attempts < maxRetries) {
          attempts++;
          setTimeout(tryScroll, interval);
        }
      }
      tryScroll();
    }

    const selectedSwatch = getCookie("variantName");

      if (selectedSwatch) {
        const cleanedSwatch = selectedSwatch
  .replace(/-(straight|wavy).*$/i, "")
  .trim();
        const colorSelector = `.media-swatch.border[data-category="${cleanedSwatch}"]`;
        waitAndScroll(colorSelector);
      }

    const selectedLength = getCookie("hairLength");
    if (selectedLength) {
      const hairSelector = `.variant-picker__option-values [data-value="${selectedLength.toLowerCase()}"]`;
      waitAndScroll(hairSelector);
    }
  }, 1000);
});









const myInterval = setInterval(variantLableChange, 0);
let colorInterval = setInterval(colorLableChange, 0);
function variantLableChange() {
  let hasFreeHalo = false;
  $(".item_swtch_label").each(function () {
    var currentText = $(this).text();
    console.log("current Text",currentText);
    if (currentText.includes("+ 1 FREE HALO")) {
      var updatedText = currentText.replace("+ 1 FREE HALO", "").trim();
      $(this).text(updatedText);
      hasFreeHalo = true;
    }
  });
  if (!hasFreeHalo) {
    clearInterval(myInterval);
  }
}

function colorLableChange() {
  let hasFreeHalo = false;
  let colorOption = $(".Color-optionvalue"); // Select the element directly
  if (colorOption.length) {
    let currentText = colorOption.text();
    console.log("current Color Lable ",currentText);
    if (currentText.includes("+ 1 FREE HALO")) {
      let updatedText = currentText.replace("+ 1 FREE HALO", "").trim();
      colorOption.text(updatedText);
      hasFreeHalo = true;
    }
  }
  if (!hasFreeHalo) {
    clearInterval(colorInterval);
  }
  
}





gsap.utils.toArray(".comparisonSection").forEach((section) => {
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top center",

      end: () => "+=" + section.offsetWidth,
      scrub: true,
      pin: true,
      anticipatePin: 1,
    },
    defaults: { ease: "none" },
  });

  tl.fromTo(
    section.querySelector(".afterImage"),
    { xPercent: 100, x: 0 },
    { xPercent: 0 }
  ).fromTo(
    section.querySelector(".afterImage img"),
    { xPercent: -100, x: 0 },
    { xPercent: 0 },
    0
  );
});

$(document).ready(function () {


  $(".howtoinstall-block .installation-steps").slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      dots: true,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            infinite: true,
            centerMode: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 350,
          settings: {
            infinite: true,
            centerMode: true,
            slidesToShow:1,
            slidesToScroll: 1,
          },
        },
      ],
  });

  $(".gallery-block .gallery-images").slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: false,
      autoplay: false,
      dots: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 640,
          settings: {
            autoplay: true,
            autoplaySpeed: 0,
            speed: 6000,
            cssEase:'linear',
            infinite: true,
            focusOnSelect: false,
            centerMode: true,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 400,
          settings: {
            autoplay: true,
            autoplaySpeed: 0,
            speed: 6000,
            cssEase:'linear',
            infinite: true,
            focusOnSelect: false,
            centerMode: true,
            slidesToShow:1,
            slidesToScroll: 1,
          },
        },
      ],
  });



   $(".custom-heroslider .slider_block").slick({
      infinite: false,
      draggable: false,
      swipe: false,
      touchMove: false,
      swipeToSlide: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      dots: false,
  });
  

  function logoSlider() {
    $(".as-feat-section .main-logo-section").slick({
      infinite: !0,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: !1,
      autoplay: !0,
      autoplaySpeed: 2e3,
      dots: !1,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
  $(window).resize(function () {
    $(window).width() <= 991 && logoSlider();
  }),
    $(window).width() <= 991 && logoSlider();
});

$(document).on("click", "input.cus-size_t", function () {
  if ($(this).is(":checked")) {
    $(".Color-optionvalue").hide();
        setTimeout(() => {
          colorLableChange();
          $(".Color-optionvalue").show();
        }, "10");
    
    var cusprice = $(this).data("vp");
    if (cusprice >= "$30") {
      $(".free-ship-label").show();
    } else {
      $(".free-ship-label").hide();
    }
  }
});

$(document).ready(function () {
  function fxn() {
    $(".product-info__buy-buttons .cpb-panels-tabs-button").addClass(
      "show_insider"
    ),
      setTimeout(function () {
        $(".product-info__buy-buttons .cpb-panels-tabs-button").removeClass(
          "show_insider"
        );
      }, 500);
  }
  setInterval(fxn, 5000);
});

// $(document).ready(function(){
// Retrieve and set the checked state on page load
//   var checkedCheckbox = sessionStorage.getItem("checkedCheckbox");
// if (checkedCheckbox) {
//   $(
//     ".shopify-section--featured-product .cus-color_v[value='" +
//       checkedCheckbox +
//       "']"
//   ).attr("checked", "checked");
// }

// Attach a click event handler to all checkboxes with class "cus-color_v"
$(".shopify-section--featured-product .cus-color_v").on("click", function () {
  // Remove the "checked" attribute from all checkboxes
  $(".shopify-section--featured-product .cus-color_v").removeAttr("checked");

  // Add the "checked" attribute only to the clicked checkbox
  $(this).attr("checked", "checked");

  // Store the checked state in localStorage
  // sessionStorage.setItem("checkedCheckbox", $(this).val());
});

// Function to update images on page load
function updateImagesOnLoad2() {
  var cusvimgurlacsload2 = $(
    ".shopify-section--featured-product .cus-color_v:checked"
  ).data("value2");
  // Show or hide images based on the selected color variant
  $(
    ".shopify-section--featured-product .product-gallery__thumbnail-list.c-temp-product-gallery__thumbnail-list img"
  ).each(function () {
    var cusvimgurlthumbload2 = $(this).data("value");
    if (cusvimgurlacsload2 == cusvimgurlthumbload2) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });

  // Additional code for main images (if needed)
  // ...
}
// });

// Function to update images on page load
function updateImagesOnLoad() {
  var cusvimgurlacsload = $(
    ".variant-picker__option-values input.cus-color_v:checked"
  ).data("value2");

  // Show or hide images based on the selected color variant
  $(
    ".product-gallery__thumbnail-list.c-temp-product-gallery__thumbnail-list img"
  ).each(function () {
    var cusvimgurlthumbload = $(this).data("value");
    if (cusvimgurlacsload == cusvimgurlthumbload) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });

  // Additional code for main images (if needed)
  // ...
}

$(document).ready(function () {
  // Retrieve the last selected value from sessionStorage
  var lastSelectedValue = sessionStorage.getItem("lastSelectedValue");

  // Show or hide images based on the last selected value
  if (lastSelectedValue) {
    updateImages(lastSelectedValue);
  }

  // Update images on page load
  updateImagesOnLoad();
  updateImagesOnLoad2();
  // Handle click event for color variants
  // $(document).on("click", '.variant-picker__option-values input.cus-color_v', function () {
  //     var cusvimgurl = $(this).data('value2');
  //     // Save the selected value to sessionStorage
  //     sessionStorage.setItem('lastSelectedValue', cusvimgurl);
  //     // Show or hide images based on the selected value
  //     updateImages(cusvimgurl);
  //   $('.cus-click-show').show();
  //   $('.cus-click-hide').hide();
  // });
  $(document).ready(function () {
    initializeVariantSliders();
    // Function to check and update the session storage
    function checkAndUpdateStorage() {
      // Get the current URL
      var currentUrl = window.location.href;

      // Check if the variant ID is present in the URL
      if (!currentUrl.includes("variant=")) {
        // Variant ID is not present, remove the lastSelectedValue from sessionStorage
        localStorage.removeItem("lastSelectedValue");
      }
    }

    // Check for changes in the URL when the page loads
    checkAndUpdateStorage();

    // Check for changes in the URL on popstate (back/forward navigation)
    $(window).on("popstate", checkAndUpdateStorage);

    // Check if there is a stored value in local storage
    var lastSelectedValue = localStorage.getItem("lastSelectedValue");

    // If there is a stored value, execute the logic
    if (lastSelectedValue) {
      updateImages(lastSelectedValue);
      $(".cus-click-show").show();
      $(".cus-click-hide").hide();
    }

    // Add the click event handler
    $(document).on(
      "click",
      ".variant-picker__option-values input.cus-color_v",
      function () {
        $(".Color-optionvalue").hide();
        setTimeout(() => {
          colorLableChange();
          $(".Color-optionvalue").show();
        }, "10");
        let redirectElement = $(this).closest('.redirect'); 
        if (redirectElement.length) {
          let redirectUrl = redirectElement.attr('href');
          if (redirectUrl) {
            window.location.href = redirectUrl;
            return;
          }
        }

        var cusvimgurl = $(this).data("value2");
        var cusVImgUrl = $(this).data("v-img2");
        localStorage.setItem("lastSelectedValue", cusvimgurl);
        updateImages(cusvimgurl);
        $(".cus-click-show").show();
        $(".cus-click-hide").hide();

        initializeSlickSlider(cusVImgUrl);

      }
    );

  });

  // Function to update images based on the selected value
  function updateImages(selectedValue) {
    $(
      ".product-gallery__thumbnail-list.c-temp-product-gallery__thumbnail-list img"
    ).each(function () {
      // var cusvimgurlacs = $('.variant-picker__option-values input.cus-color_v').val();
      var cusvimgurlthumb = $(this).data("value");
      // alert(cusvimgurlthumb);
      if (selectedValue == cusvimgurlthumb) {
        $(this).addClass('matched');
        $(this).show();
      } else {
        $(this).removeClass('matched');
        $(this).hide();
      }
    });

    $(".product-gallery__media.c-temp-product-gallery__media img").each(
      function () {
        // var cusmainimgurl = $(this).data('main-img');
        var cusmainimgurl = $(this).data("value4");
        if (selectedValue == cusmainimgurl) {
          $(this).addClass('matched');
          $(this).show();
        } else {
          $(this).removeClass('matched');
          $(this).hide();
        }
      }
    );

    $(".product-gallery__media.c-temp-product-gallery__media").each(
      function () {
        // var cusmainimgurl2 = $(this).data('main-img-div');
        var cusmainimgurl2 = $(this).data("value3");
        if (selectedValue == cusmainimgurl2) {
          $(this).addClass('matched');
          $(this).show();
        } else {
          $(this).removeClass('matched');
          $(this).hide();
        }
      }
    );
  }
function initializeSlickSlider(cusvimgurl) {
  if ($(".cus-click-show.product-gallery__media-list").hasClass("slick-initialized")) {
    $(".cus-click-show.product-gallery__media-list").slick("unslick");
  }
  if ($(".custom-gallery-slider-thumbnails-js").hasClass("slick-initialized")) {
    $(".custom-gallery-slider-thumbnails-js").slick("unslick");
  }
  
  const matchedItems = $(".custom-gallery-slider-thumbnails .slick-item.matched").clone();

  const selectVariantImage = $("<img>", {
    src: cusvimgurl,
    class: "slick-item sourceImage val matched",
    alt: "Main Variant Image",
    style: "width: 100%; height: auto;",
    loading: "eager"
});

  // var firstImageUrl = $(".variant-picker__option-values input.cus-color_v").data("firstimg");
  //   const firstImage = $("<img>", {
  //     src: firstImageUrl,
  //     class: "slick-item sourceImage val matched live-added",
  //     alt: "Newly Added Image",
  //     style: "width: 100%; height: auto;",
  //     loading: "eager"
  //   });

  const updatedItems = [selectVariantImage[0], ...matchedItems.toArray()];

  const wrappedContent = $(updatedItems).map(function () {
    return $("<div>", {
      class: "product-gallery__media c-temp-product-gallery__media",
    }).append($(this).clone())[0];
  });


  const wrappedContentJQ = $(wrappedContent);

  $(".cus-click-show.product-gallery__media-list").empty().append(wrappedContentJQ);
  if (matchedItems.length > 0 && $(".custom-gallery-slider-thumbnails-js").length > 0) {
    $(".custom-gallery-slider-thumbnails-js").empty().append(updatedItems);
  } else {
    console.error("Matched items or target container is missing.");
  }
  
$(".cus-click-show.product-gallery__media-list").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
   
});

$(".custom-gallery-slider-thumbnails-js").slick({
    slidesToShow: 9.5,
    slidesToScroll: 1,
    asNavFor: ".cus-click-show.product-gallery__media-list",
    dots: false,
    centerMode: false, 
    focusOnSelect: true,
    infinite: false,   
    variableWidth: false, 
});

$(".cus-click-show.product-gallery__media-list").on("afterChange", function (event, slick, currentSlide) {
    
    const $thumbnailsSlider = $(".custom-gallery-slider-thumbnails-js");
    


    $thumbnailsSlider.find('.slick-slide').removeClass('slick-current slick-active');

    $thumbnailsSlider.find(`[data-slick-index="${currentSlide}"]`).addClass('slick-current slick-active');
  });



  //    if (cusvimgurl) {
  //   // Add the live new image and the new image item to the main slider
  //   const newMainItems = [
  //     // $("<div>", {
  //     //   class: "product-gallery__media c-temp-product-gallery__media",
  //     // }).append(firstImage),
  //     $("<div>", {
  //       class: "product-gallery__media c-temp-product-gallery__media",
  //     }).append(selectVariantImage),
  //   ];

  //   // Add the live new image and new image item to the thumbnail slider
  //   // $(".custom-gallery-slider-thumbnails-js").slick('slickAdd', firstImage);
  //   $(".custom-gallery-slider-thumbnails-js").slick('slickAdd', selectVariantImage);
  //       // Add the rest of the variant images after
  //   matchedItems.each(function() {
  //     $(".custom-gallery-slider-thumbnails-js").slick('slickAdd', this);
  //   });

  //   // Add the new images to the main slider as well
  //   newMainItems.forEach(item => $(".cus-click-show.product-gallery__media-list").slick('slickAdd', item));
  // }
}



});

// Wrap the code in the DOMContentLoaded event
// document.addEventListener("DOMContentLoaded", function() {
//     // Get all target images by class name
//     var targetImages = document.getElementsByClassName("targetImage");

//     // Get all source images by class name
//     var sourceImages = document.getElementsByClassName("sourceImage");

//     // Add click event listener to each source image
//     for (var i = 0; i < sourceImages.length; i++) {
//         sourceImages[i].addEventLvistener("click", function() {
//             // Get the clicked image path
//             var clickedImagePath = this.src;

//             // Set the target image src attribute to the clicked image path
//             for (var j = 0; j < targetImages.length; j++) {
//                 targetImages[j].src = clickedImagePath;
//             }
//         });
//     }
// });
document.addEventListener("DOMContentLoaded", function () {
  var targetImages = document.getElementsByClassName("targetImage");
  var sourceImages = document.getElementsByClassName("sourceImage");

  // Check if a selected image is stored in localStorage
  var storedImagePath = sessionStorage.getItem("selectedImagePath");
  if (storedImagePath) {
    for (var j = 0; j < targetImages.length; j++) {
      targetImages[j].src = storedImagePath;
    }
  }

  for (var i = 0; i < sourceImages.length; i++) {
    sourceImages[i].addEventListener("click", function () {
      var clickedImagePath = this.src;

      // Set the target image src attribute to the clicked image path
      for (var j = 0; j < targetImages.length; j++) {
        targetImages[j].src = clickedImagePath;
      }

      // Store the selected image path in localStorage
      sessionStorage.setItem("selectedImagePath", clickedImagePath);
    });
  }
});
// Wrap the code in the DOMContentLoaded event
// document.addEventListener("DOMContentLoaded", function() {
//     // Get all target images by class name
//     var targetImages = document.getElementsByClassName("targetImage");

//     // Get all source images by class name
//     var sourceImages = document.getElementsByClassName("sourceImage2");

//     // Add click event listener to each source image
//     for (var i = 0; i < sourceImages.length; i++) {
//         sourceImages[i].addEventListener("click", function() {
//             // Get the clicked image path from the data-src attribute
//             var clickedImagePath = this.getAttribute("data-v-img2");

//             // Set the target image src attribute to the clicked image path
//             for (var j = 0; j < targetImages.length; j++) {
//                 targetImages[j].src = clickedImagePath;
//             }
//         });
//     }
// });

document.addEventListener("DOMContentLoaded", function () {
  var targetImages = document.getElementsByClassName("targetImage");
  var sourceImages = document.getElementsByClassName("sourceImage2");

  // Check if a selected image is stored in localStorage
  var storedImagePath = sessionStorage.getItem("selectedImagePath");
  if (storedImagePath) {
    // Set the target image src attribute to the stored image path
    for (var j = 0; j < targetImages.length; j++) {
      targetImages[j].src = storedImagePath;
    }
  }

  // Add click event listener to each source image
  for (var i = 0; i < sourceImages.length; i++) {
    sourceImages[i].addEventListener("click", function () {
      var clickedImagePath = this.getAttribute("data-v-img2");

      // Set the target image src attribute to the clicked image path
      for (var j = 0; j < targetImages.length; j++) {
        targetImages[j].src = clickedImagePath;

        // Store the selected image path in localStorage
        sessionStorage.setItem("selectedImagePath", clickedImagePath);
      }
    });
  }
});

$("a[href^='#'].cus_click-scroll").click(function (e) {
  e.preventDefault();

  var position = $($(this).attr("href")).offset().top;

  $("body, html").animate(
    {
      scrollTop: position,
    } /* speed */
  );
});

// $(document).ready(function () {
//   $(".custom-cart-recommandation_slider").slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: true,
//     appendArrows: $(".related_slider_arrows"),
//   });
// });

// ----------Custom---------
$(document).ready(function () {
  $(".main-box-slide").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
  });

  $(".slider-video").slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".custom-image-scroll").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots:true,
    arrows:false
  });
  
  if (window.innerWidth <= 768) {
    // Agar viewport width 768 se chhota hai (mobile device)
    $(".cus-videos-text-slider").slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });
  }

  function playVideo(video) {
    if (video[0].paused) {
      video[0].play();
    } else {
      video[0].pause();
    }
  }
  $(document).on("click", ".play-gif", function () {
    var video = $(this).parents(".video-inner-container").find("video");
    $(this).hide();
    $(this).parents(".video-container").addClass("video-play");
    playVideo(video);
  });

  $(document).on("click", ".video-container video", function () {
    var video = $(this);
    $(this).parents(".video-container").find(".play-gif").show();
    $(this).parents(".video-container").removeClass("video-play");
    playVideo(video);
  });

  $(document).on("click", ".cart-drawer-quantity-selector button", function () {
    var DrawerQuantity = $(this)
      .parents(".quantity-selector")
      .find("input.quantity-selector__input")
      .val();
    var DrawerlineKey = $(this)
      .parents(".quantity-selector")
      .find("input.quantity-selector__input")
      .attr("data-line-key");
    let element = document.querySelector(
      '[data-line-key="' + DrawerlineKey + '"]'
    );
    element.value = DrawerQuantity;
    var u = document.createEvent("Events");
    u.initEvent("change", !0, !1);
    jQuery(element)[0].dispatchEvent(u);
  });

  $(document).on(
    "click",
    ".line-item__actions .quantity-selector button",
    function () {
      // debugger
      var DrawerQuantity = $(this)
        .parents(".quantity-selector")
        .find("input.quantity-selector__input")
        .val();
      
      var DrawerlineKey = $(this)
        .parents(".quantity-selector")
        .find("input.quantity-selector__input")
        .attr("data-line-key");
      let element = document.querySelector(
        '[data-line-key="' + DrawerlineKey + '"]'
      );
      element.value = DrawerQuantity;
      var u = document.createEvent("Events");
      u.initEvent("change", !0, !1);
      jQuery(element)[0].dispatchEvent(u);
    }
  );
});

window.onload = () => {
  let checkedBundle = document.querySelector(".bundle-swatch .self_checked");
  if (checkedBundle !== null) {
    checkedBundle.checked = true;
  var e = document.createEvent("Events");
  e.initEvent("change", !0, !1);
  jQuery(checkedBundle)[0].dispatchEvent(e);
  }
};

// PRODUCT UPSELL ITEM ADD JS

// function cartDrawerOpen() {
//   $("cart-drawer").attr("open", "");
//   $("cart-drawer").addClass("show-close-cursor");
//   $("cart-drawer").css({
//    'opacity' : '1',
//    'visibility' : 'visible'
//   });
// }

$(document).ready(function () {
  $(".upsell-btn-js").click(function () {
    $(this)
      .parents(".upsell--with_button")
      .find(".upsell__popup")
      .show()
      .addClass("active")
      .attr("open", "");
    $(this)
      .parents(".upsell--with_button")
      .find(".upsell__popup-overlay")
      .addClass("active");
    $("body").addClass("overflow-hidden");
  });

  $(".upsell__popup-overlay").click(function () {
    $(this)
      .parents(".upsell--with_button")
      .find(".upsell__popup")
      .hide()
      .removeClass("active")
      .removeAttr("open");
    $(this).parents(".upsell--with_button").find(".upsell__popup").css({
      bottom: "-100px",
    });
    $(this).removeClass("active");
    $("body").removeClass("overflow-hidden");
  });

  $(".close").click(function () {
    $(this)
      .parents(".upsell--with_button")
      .find(".upsell__popup")
      .hide()
      .removeClass("active")
      .removeAttr("open");
    $(this)
      .parents(".upsell--with_button")
      .find(".upsell__popup-overlay")
      .removeClass("active");
    $("body").removeClass("overflow-hidden");
  });

  $(".upsell__popup .Add-on").on("click", function () {
    var valuesArray = "";
    $(".upsell__popup[open] .Add-on:checked").each(function () {
      var optionValue = $(this).val().replace(/,/g, ""); // Remove commas from the value
      valuesArray = `${valuesArray} ${optionValue}`;
    });
    // console.log("valuesArray = ", valuesArray);

    // Convert valuesArray to string and then trim
    var trimmedValue = String(valuesArray).trim();

    // Get the value and src attributes based on the selected variant
    var selectedVariant = $(`.upsell__popup[open] .custom-variant__dropdown .select option[data-variant="${trimmedValue}"]`);
    var onChangeGetVariantID = selectedVariant.data("value");
    var onChangeGetVariantImageSrc = selectedVariant.data("src");

    // var onChangeGetVariantID = $(`.upsell__popup[open] .custom-variant__dropdown .select option[data-variant="${$(valuesArray).trim()}"]`).data("value");
    // var onChangeGetVariantImageSrc = $(`.upsell__popup[open] .custom-variant__dropdown .select option[data-variant="${$(valuesArray).trim()}"]`).data("src");
    // console.log(onChangeGetVariantImageSrc);

    var onChangeGetVariantValue = $(this).val();
    $(this)
      .parents(".upsell__popup")
      .find(".cus_click-scroll")
      .attr("data-id", onChangeGetVariantID);
    $(this)
      .parents(".variant-picker__option")
      .find("variant-option-value")
      .html(onChangeGetVariantValue);
    $(this)
      .parents(".upsell__popup")
      .find(".upsell_image img")
      .attr("src", onChangeGetVariantImageSrc);
  });

  $(document).on("click", ".upsell__popup .cus_click-scroll", function (e) {
    var variantID = $(this).data("id");
    $(this).addClass("loading");
    addToCartJS(1, variantID, this);
  });

  $('.size-guide').click(function() {
    $('.size-guide-popup').show();
    $('.size-guide-popup').addClass('active');
    $('body').addClass('open-popup');
  });
  
  $('.size-guide-popup .close-btn').click(function() {
    $('.size-guide-popup').hide();
    $('.size-guide-popup').removeClass('active');
    $('body').removeClass('open-popup');
  }); 
  
});

// New custom JS Naveed


const $productFormCustom = $(".js-product-form--custom");
const $countBubble = $("body .count-bubble");

// Simplify isCart() function
function isCart() {
  return document.URL.includes("/cart");
}


// document.addEventListener("variant:change", function (event) {
//   console.log(event.detail.variant);
//   let variantTitle = event.detail.variant.title;
//   variantTitle = variantTitle.replace("+ 1 FREE HALO ", "");
//   variantTitle = variantTitle.replace("+ FREE HALO ", "");
//   // console.log(variantTitle);
//   var option = $('.js-freeGiftSelect option').filter(function() {
//     return $(this).text().trim() === variantTitle.trim();
//   });
//   option.prop("selected", true);
//   var giftVId = option.data("variantid");
//   $productFormCustom.find("input.gift-value--js").val(giftVId);
// });

document.addEventListener("variant:change", function (event) {
  const variant = event.detail.variant;

  // ✅ Update Wavy Image
  if (variant.featured_image && variant.featured_image.src) {
    let wavy = variant.featured_image.src;
    let wavyResized = wavy.replace(/(\.[^.]*)$/, "_200x$1");
    $(".wavy--product img").attr("src", wavyResized);
  }

  // ✅ Update Variant Title Logic
  let variantTitle = variant.title || "";
  console.log("variantTitle:", variantTitle);

  variantTitle = variantTitle.replace("+ 1 FREE HALO ", "").replace("+ FREE HALO ", "");

  if ($("body").hasClass("template--product-pre-order") || $("body").hasClass("template--product-straight-single-extension")) {
    let parts = variantTitle.split(" / ");
    if (parts.length > 1) {
      variantTitle = parts[1] + " / " + parts[0];
    }
  }

  let parts = variantTitle.split(" / ");
  if (parts.length > 1) {
    if ($(".variant-picker__option-values-length").hasClass("pdp2-variant-selected")) {
      const selectedLength = $(".length-option.selected .swatch-label-text").text().trim();
      if (selectedLength) {
        parts[1] = selectedLength;
      }
    }
    variantTitle = parts[0] + " / " + parts[1];
  }

  console.log("Updated variant title:", variantTitle);

  // ✅ Update Wavy Image Based on Variant Title
  const $wavyOption = $('.js-freeGiftImage.wavy-Image-Js option').filter(function () {
    return $(this).text().trim() === variantTitle.trim();
  });

  const wavyImage = $wavyOption.data("image");
  if (wavyImage) {
    $(".wavy--product img").attr("src", wavyImage);
  }

  // ✅ Update Price With Discount (if available)
  if ($wavyOption.length) {
    const discountPercent = parseFloat($wavyOption.attr("discount_percentage")) || 0;
    const originalPrice = variant.price;
    const discountAmount = originalPrice * (discountPercent / 100);
    const discountedPrice = originalPrice - discountAmount;

    // Update text content
    const priceSpan = document.getElementById("variant-price");
    if (priceSpan && typeof Shopify !== "undefined" && Shopify.formatMoney) {
      priceSpan.textContent = Shopify.formatMoney(discountedPrice, Shopify.money_format);
    }

    // setTimeout(() => {
    //   $("#custom-buy-button").find('#variant-price').text(`$${(discountedPrice / 100).toFixed(2)}`);
    // }, 100);
    
  }

  // ✅ Update Gift Image and Hidden Input
  const $option = $('.js-freeGiftSelect option').filter(function () {
    return $(this).text().trim() === variantTitle.trim();
  });

  if ($option.length) {
    $option.prop("selected", true);

    const straightImage = $option.data("image");
    if (straightImage) {
      $(".Free--straight--product img").attr("src", straightImage);
    }

    const giftVId = $option.data("variantid");
    if (giftVId && typeof $productFormCustom !== "undefined") {
      $productFormCustom.find("input.gift-value--js").val(giftVId);
    }
  }

  // ✅ Trigger color label update if function exists
  if (typeof colorLableChange === "function") {
    colorLableChange();
  }
});




$(document).on("click", ".link.main-product--true", function(event) {
  event.preventDefault();
  $('cart-drawer.cart-drawer').addClass('cart_loading');
  const $this = $(this);
  const updates = {};
  updates[$this.data("line-id")] = 0;

  if (isCart()) {
    $this.parents(".cart-line-item").find(".list-disc input.freegiftId").each(function() {
      updates[$(this).val()] = 0;
    });
  } else {
    $this.closest(".line_item_details").find(".list-disc input.freegiftId").each(function() {
      updates[$(this).val()] = 0;
    });
  }

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates }),
  })
  .then(response => response.json())
  .then(dataResponse => {
    let itemCount = dataResponse.item_count;
    setTimeout(() => {
      $countBubble.text(itemCount);
    }, 2500);

    if (isCart()) {
      location.reload();
    } else {
      document.dispatchEvent(new Event("cart:refresh", { bubbles: true }));
      $('cart-drawer.cart-drawer').removeClass('cart_loading');
      $(".item_swtch_label").hide();
      
        setTimeout(() => {
         variantLableChange();
         
          $(".item_swtch_label").show();

        }, "10");
      
      console.log("variantLableChange()");

      setTimeout(() => {
        clearInterval(myInterval);
      }, 2000);

      if (typeof initCartDrawerRecommendationsSlider === "function") {
        setTimeout(function () {
          initCartDrawerRecommendationsSlider();
        }, 2000);
      }
    }
  })
  .catch(error => {
      console.error("Error:", error);
      $('.cart-drawer.cart-drawer').removeClass('cart_loading');
    });
  
});


// document.addEventListener('cart:change', function(event) {
//   console.log('working')
//   var cart = event.detail.cart;
//   console.log(cart)
// });




// Function to increase quantity
function increaseQuantity(event) {
  var updates = { "updates": {} };
  var $currentLineItem =  $(event).closest('.line-item');
  var $metaProperties = $currentLineItem.find('.line-item__info');
  var $quantityInput = $currentLineItem.find('.quantity-selector__input');
  var quantity = parseInt($quantityInput.val()) + 1;
  $quantityInput.val(quantity);

  updates.updates[$(event).data('line-id')] = quantity;

  if ($metaProperties.find('input.freegiftId').length > 0) { 
    $metaProperties.find('input.freegiftId').each(function(index, data) {
      let vId = $(this).val();
      updates.updates[vId] = quantity;
    });
  }

  cartUpdated(updates);
}

// Function to decrease quantity
function decreaseQuantity(event) {
  var updates = { "updates": {} };
  var $currentLineItem =  $(event).closest('.line-item');
  var $metaProperties = $currentLineItem.find('.line-item__info');
  var $quantityInput = $currentLineItem.find('.quantity-selector__input');
  var quantity = parseInt($quantityInput.val()) - 1;
  if (quantity < 0) {
    quantity = 0;
  }
  $quantityInput.val(quantity);

  updates.updates[$(event).data('line-id')] = quantity;

  if ($metaProperties.find('input.freegiftId').length > 0) { 
    $metaProperties.find('input.freegiftId').each(function(index, data) {
      let vId = $(this).val();
      updates.updates[vId] = quantity;
    });
  }

  cartUpdated(updates);
}


// Function to update cart
function cartUpdated(updates) {
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: $.param(updates)
  })
.then(response => {
  if (response.ok) {
    return response.json().then(dataResponse => {
      let itemCount = dataResponse.item_count;
      setTimeout(() => {
        $countBubble.text(itemCount);
      }, 2500);

      if (isCart()) {
        location.reload();
      } else {
              document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
            })
          );
        
      }
       setTimeout(() => {
        variantLableChange();
      }, 1000);
      
      $('.cart-drawer.cart-drawer').removeClass('cart_loading');
    });
  } else {
    console.log(response);
    $('.cart-drawer.cart-drawer').removeClass('cart_loading');
    throw new Error('Error updating cart');
  }
})
  .catch((error) => {
    $('.cart-drawer.cart-drawer').removeClass('cart_loading');
    console.error('Error:', error);
    // Handle error here
  });
}

// Event listeners
$(document).on('click', '.quantity_remove--button.minus', function(event) {
   $('cart-drawer.cart-drawer').addClass('cart_loading');
  decreaseQuantity($(this));
});

$(document).on('click', '.quantity_remove--button.plus', function(event) {
  $('cart-drawer.cart-drawer').addClass('cart_loading');
  increaseQuantity($(this));
});


document.addEventListener("cart:change", function (event) {
  variantLableChange();
});


$(document).on(
  "click",
  ".purchase-details__buttons .product-form__add-button",
  function (e) {
    e.preventDefault();
    var $this = $(this);
    $this.attr("disabled", true);
    $this.append("<div class='custom_loader'></div>");
    $this.find("span").hide();
    $this.find(".add-icon").hide();
    let upsellId = $this.closest("form").find("input[name=id]").val();
    if (upsellId) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: 1,
          id: upsellId,
        },
        dataType: "json",
        success: function (data) {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
            })
          );
          if (!document.getElementById("mini-cart").open == true) {
            document.getElementById("mini-cart").open = true;
          }
          setTimeout(function () {
            $this.find("span").show();
            $(".custom_loader").remove();
            $this.attr("disabled", false);
          }, 500);
        },
        error: function (XMLHttpRequest) {
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          if (response) {
            response = response.description;
            $(".warning").remove();
            var warning =
              '<p class="warning animated bounceIn">' +
              response.replace("All 1 ", "All ") +
              "</p>";
            $this.after(warning);
          }
        },
      });
    }
  }
);




// $('.buy-buttons.buy-buttons--compact').on('click', function(event) {
//   event.preventDefault();
//   $(this).find('button').attr('aria-busy','true');
//   const updates = { updates: {} };

//   cartValidityFinalCheck(updates);
// });

// function cartValidityFinalCheck(updates) {
//   fetch(window.Shopify.routes.root + 'cart.js')
//   .then(response => response.json())
//   .then(cartData => {
//     validateCartContents(cartData, updates);
//   })
//   .catch(error => {
//     console.error('Error fetching cart data:', error);
//     alert("Error fetching cart data");
//   });
// }

// function validateCartContents(cartData, updates) {
//   const lineItems = cartData.items;

//   let needsUpdate = false;

//   lineItems.forEach(lineItem => {
//     console.log('checking items, ' + lineItem.title)
//     if (lineItem.properties && lineItem.properties.freegiftId) {
//       const freeVariantId = lineItem.properties.freegiftId;

//       const hasFreeProduct = lineItems.some(otherLineItem => {
//         return otherLineItem.variant_id === freeVariantId;
//       });

//       if (!hasFreeProduct) {
//         const primaryProductQuantity = lineItem.quantity;

//         const newLineItem = {
//           variant_id: freeVariantId,
//           quantity: primaryProductQuantity
//         };

//         updates.updates[newLineItem.variant_id] = newLineItem.quantity;

//         needsUpdate = true;
//       }
//     }

//     if (lineItem.price === 0) {
//       const freeVariantId = lineItem.variant_id;

//       const hasFreeVariant = lineItems.some(otherLineItem => {
//         return otherLineItem.properties && otherLineItem.properties.freegiftId === freeVariantId;
//       });

//       if (!hasFreeVariant) {
//         updates.updates[lineItem.id] = 0;

//         needsUpdate = true;
//       }
//     }
//   });

//   if (needsUpdate) {
//     fetch(window.Shopify.routes.root + 'cart/update.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/x-www-form-urlencoded'
//       },
//       body: $.param(updates)
//     })
//     .then(response => {
//       if (response.ok) {
//         alert(" testing - response OK ")
//         // document.location.href = '/cart/checkout';
//       } else {
//         alert("Error updating cart");
//       }
//     })
//     .catch(error => {
//       alert("Cart condition do not fulfill, Error Updating cart")
//       console.error('Error updating cart: ', error)
//     });
//   } else {
//     alert(" testing - response Not OK ")
//     // document.location.href = '/cart/checkout';
//   }
// }



$(document).ready(function () {
  var interval;
  interval = setInterval(function () {
    if ($(".latest-cart-drawer").length > 0) {
      if (
        $(".custom-cart-recommandation_slider.slick-initialized").length <= 0
      ) {
        $(".custom-cart-recommandation_slider").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          appendArrows: $(".related_slider_arrows"),
        });
      }
    }
  }, 500);

  $(".item_swtch_label").each(function () {
    var currentText = $(this).text();
    if (currentText.includes("+ 1 FREE HALO")) {
      var updatedText = currentText.replace("+ 1 FREE HALO", "").trim();
      $(this).text(updatedText);
    }
  });

//    document.addEventListener("line-item:change", function (event) {
//   var updates = {};    
//   let data = event.detail.cart;
//   let items = data.items;
  
//   for (var i = 0; i < items.length; i++) {
//     if (items[i].properties["_free gift 1"] !== null && typeof items[i].properties["_free gift 1"] !== "undefined") {
//       updates[items[i].properties["_free gift 1"]] = items[i].quantity;
//     }
//   }

//   fetch(window.Shopify.routes.root + "cart/update.js", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({ updates }),
//   })
//     .then((response) => {
//       if (isCart()) {
//         location.reload();
//       } else {
//         return response.json();
//       }
//     })
//     .then((response) => {
//       // alert(`Item count: ${response.item_count}`);
      
//         $("body .count-bubble").text(response.item_count);
  
      
//       const myInterval = setInterval(variantLableChange, 0);
//       console.log("variantLableChange()")
//       function variantLableChange() {
//         $(".item_swtch_label").each(function () {
//           var currentText = $(this).text();
//           if (currentText.includes("+ 1 FREE HALO")) {
//             var updatedText = currentText.replace("+ 1 FREE HALO", "").trim();
//             $(this).text(updatedText);
//             clearInterval(myInterval);
//           }
//         });
//       }

//       setTimeout(function () {
//         clearInterval(myInterval);
//       }, 2000);
//     })
//     .catch((error) => {
//       console.error("Error:", error);
//     });
// });

  
});


$(document).ready(function(){
   function isInViewport(theDiv) {
      let elementTop = theDiv.offset().top;
      let elementBottom = elementTop + theDiv.outerHeight();
      let viewportTop = $(window).scrollTop();
      let viewportBottom = viewportTop + window.innerHeight;
      return elementBottom > viewportTop && elementTop < viewportBottom;
      }
      var animationDone = false;
      if ($('.pro_vid_img_sec').length) {
      $(window).on('scroll', function(){
        if (!animationDone) {
        if(isInViewport($('.pro_vid_img_sec'))) {
  
          animationDone = true;
          $(".circleBarProgress").each(function () {
          
            var x = $(this).find(".circleBarWrapper"),
                i = $(this).find("span"),
                e = parseInt(i.text(), 10);
            $({ p: 0 }).animate(
                { p: e },
                {
                    duration: 3e3,
                    easing: "swing",
                    step: function (e) {
                        x.css({background: "conic-gradient(#d5bba9 0deg " + e + "%, #f0ded9 " + e + "%)"}), i.text(0 | e);

                    },
                }
            );
          });
        }
      }
      });
      }
});
 

// function checkAndRefreshCartDrawer(cart) {

//   console.log('cart.item_count '+ cart.item_count);
  
  
//   setTimeout(function() {
//     if (cart.item_count > 0) {
//       $("body .count-bubble").removeClass('opacity-0');
//       $("body .count-bubble").text(cart.item_count);
//     }
//   }, 300);

//   var freeGiftProductHandles = ['straight-halo-extension-1-sca_clone_freegift', '3pcs-super-comb-styling-kit-sca_clone_freegift'];

//   var anyFreeGiftsInCart = freeGiftProductHandles.some(function(handle) {
//     return cart.items.some(function(item) {
//       return item.handle === handle;
//     });
//   });

//   setTimeout(function() {
//     var drawerContainsFreeGift = freeGiftProductHandles.some(function(handle) {
//       return $('.cart-drawer__line-items').find(`[data-cart-item-handle="${handle}"]`).length > 0;
//     });

//     if ((anyFreeGiftsInCart && !drawerContainsFreeGift) || (!anyFreeGiftsInCart && drawerContainsFreeGift)) {
//       document.documentElement.dispatchEvent(
//         new CustomEvent("cart:refresh", {
//           bubbles: true,
//         })
//       );
//       console.log('Cart drawer refreshed due to a mismatch between the cart and the drawer.');
//     } else {
//       document.documentElement.dispatchEvent(
//         new CustomEvent("cart:refresh", {
//           bubbles: true,
//         })
//       );
//       console.log('Cart and drawer are in sync. No refresh needed.');
//     }
//   }, 200);
// }


//   document.addEventListener("line-item:change", function (event) {
//     console.log('working');
//     var cart = event.detail.cart; 
//     setTimeout(function() {
//         checkAndRefreshCartDrawer(cart);
//     }, 200)
// });

// document.addEventListener('variant:add', function(event) {
//   console.log('working');
//   let cart = event.detail.cart; 
//         checkAndRefreshCartDrawer(cart);
// });



$(document).on(
  "click",
  "#custom-add-to-cart-button",
  function (e) {
    e.preventDefault();
    var $this = $(this);
    $this.attr("disabled", true);
    $this.append("<div class='custom_loader'></div>");
    $this.find("span").hide();
    let upsellId = $this.closest("form").find("input[name=id]").val();
    if (upsellId) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: 1,
          id: upsellId,
        },
        dataType: "json",
        success: function (data) {
          let anchor = document.querySelector('[aria-controls="cart-drawer"]'); 
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
            })
          );
        	anchor.click(); 
          setTimeout(function () {
              $.getJSON('/cart.js', function(cartJson) {
                checkAndRefreshCartDrawer(cartJson);
            });
            }, 200);
            
          
          setTimeout(function () {
            $this.find("span").show();
            $(".custom_loader").remove();
            $this.attr("disabled", false);
            
          }, 400);
        },
        error: function (XMLHttpRequest) {
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          if (response) {
            response = response.description;
            $(".warning").remove();
            var warning =
              '<p class="warning animated bounceIn">' +
              response.replace("All 1 ", "All ") +
              "</p>";
            $this.after(warning);
          }
          setTimeout(function () {
            $this.find("span").show();
            $(".custom_loader").remove();
            $this.attr("disabled", false);  
          }, 400);
        },
      });
    }
    else {
      setTimeout(function () {
            $this.find("span").show();
            $(".custom_loader").remove();
            $this.attr("disabled", false);
          }, 400);
    }
  }
);

$(document).ready(function() {
  if($(".template-product").length > 0){
    var interval = setInterval(function() {
        if (window.location.search.includes("variant=")) {
            $('input[type="radio"].sourceImage2').each(function() {
                if ($(this).is(':checked')) {
                    $(this).trigger('click');
                }
            });
           clearInterval(interval);
        }
    }, 600);
  }
});  

// Define the initializeSliders function globally



function initializeVariantSliders() {
// For Variant click
   $('.variant-gallery-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.variant-gallery-slider-thumbnails'
  });
  $('.variant-gallery-slider-thumbnails').slick({
    slidesToShow: 9.5,
    slidesToScroll: 1,
    asNavFor: '.variant-gallery-slider',
    dots: false,
    focusOnSelect: true
  });
}
// Wait for the DOM to load
// Wait for the DOM to load
$(document).ready(function () {


    // Add click event to tabs
    document.querySelectorAll('.tab-item').forEach(tab => {
        tab.addEventListener('click', function () {
            // Remove 'active' class from all tabs and contents
            document.querySelectorAll('.tab-item').forEach(t => t.classList.remove('active'));
            document.querySelectorAll('.testimonial-item').forEach(content => content.classList.remove('active'));

            // Add 'active' class to the clicked tab and corresponding content
            this.classList.add('active');
            const tabContent = document.querySelector(`.testimonial-item[data-tab="${this.dataset.tab}"]`);
            tabContent.classList.add('active');

            

        });
    });
});



$(document).ready(function() {
  $(document).on("click", ".custom-menu-link-toggle", function (e) {
    // console.log('buttion clicked');
    $(this).closest('.has-sub-menu').toggleClass('active');
    var expandableContent = $(this).data('open');
    $('#' + expandableContent).slideToggle();
  })
})

$(document).ready(function () {
$(".color-option-js").on("click", function () {
  $(".color-option-js").removeClass("selected");
  $(this).addClass("selected");

  const selectedCategories = ($(this).data("category") || "").toLowerCase().split(", ");
  let firstMatchClicked = false;

  $(".variant-picker__option-values .media-swatch").each(function () {
    const labelCategory = ($(this).data("category") || "").toLowerCase();

    const isMatch = selectedCategories.some(category =>
      labelCategory === category || category === "all"
    );

    if (isMatch) {
      if (!firstMatchClicked) {
        $(this).trigger("click");
        firstMatchClicked = true;
      }

      $(this).show();
      let redirectElement = $(this).closest('.redirect'); 
      if (redirectElement.length) {
        redirectElement.show();
      }
    } else {
      let redirectElement = $(this).closest('.redirect'); 
      if (redirectElement.length) {
        redirectElement.hide();
      }
      $(this).hide();
    }
  });
});

// $(".color-option-js").first().trigger("click");


let isDragging = false;
let startX;
let scrollLeft;

const carousel = document.querySelector('.product-gallery__media-list');

  if (carousel != null) {
    
    carousel.addEventListener('mousedown', (e) => {
  isDragging = true;
  carousel.classList.add('active');
  startX = e.pageX - carousel.offsetLeft;
  scrollLeft = carousel.scrollLeft;
});

carousel.addEventListener('mouseleave', () => {
  isDragging = false;
  carousel.classList.remove('active');
});

carousel.addEventListener('mouseup', () => {
  isDragging = false;
  carousel.classList.remove('active');
});

carousel.addEventListener('mousemove', (e) => {
  if (!isDragging) return;
  e.preventDefault();
  const x = e.pageX - carousel.offsetLeft;
  const walk = (startX - x) * 6; 
  carousel.scrollLeft = scrollLeft + walk; 
});

carousel.querySelectorAll('img').forEach((img) => {
  img.addEventListener('dragstart', (e) => e.preventDefault());
});
    
  }



//  $('.header__icon-list .tap-area').click(function () {
//    console.log("Click");
//     if ($('.navigation-drawer').length) {
//         const navDrawer = $('<navigation-drawer></navigation-drawer>');
//         setTimeout(() => {
//            console.log(" yes");
//             navDrawer.addClass('with-transition');
//         }, 10);
//     }
// }); 

});

// document.getElementById("header-sidebar-menu").addEventListener("click", () => {
//   const drawer = document.querySelector("navigation-drawer");
//   drawer.toggleAttribute("open"); 
// });
// $(document).ready(function () {
// $("#filter_icons_js").on("click", function () {
// $("#filter-icon-open").hide();
// });
// });


$(document).ready(function () {
  $(document).on("click", ".color-option-filter-js", function (e) {
    $('.color-option-filter-js').removeClass('selected');
    $('.filter-checkbox').prop('checked', false); 
    
    $(this).addClass('selected');
    
    var selectedCategory = $(this).data('category').toLowerCase();
    
    if (selectedCategory === 'all') {
      console.log('Clicking "all" filter');
      
      var removableFacetLink = $('.collection__top-bar').find('.removable-facet').find('a');
      console.log(removableFacetLink);
      
      if (removableFacetLink.length > 0) {
        removableFacetLink[0].click(); 
      } else {
        console.log('Removable facet link not found');
      }
    } else {
      $('.filter-checkbox').each(function () {
        var checkboxValue = $(this).val().toLowerCase(); 
        if (checkboxValue === selectedCategory) {
          $(this).click();
          $(this).prop('checked', true); 
        } else {
          $(this).prop('checked', false); 
        }
      });
    }
  });
});

$(document).ready(function () {
  var $actualButton = $('buy-buttons.buy-buttons'); 
  var $stickyButton = $('#sticky-add-to-cart'); 

  function isButtonVisible() {
    if ($actualButton[0] != null) {
      var rect = $actualButton[0].getBoundingClientRect();
      return rect.top < 0;
    }
  }

  // Check if an element is in the viewport
  function isInViewport($el) {
    if ($el.length === 0) return false;
    var rect = $el[0].getBoundingClientRect();
    return (
      rect.top < window.innerHeight &&
      rect.bottom > 0
    );
  }

  function toggleStickyButton() {
    if ($('body').hasClass('template--page-latest-home-page-new')) {
      var $hideTarget = $('variant-picker[handle="hair-extensions"]');
      if (isInViewport($hideTarget)) {
        $stickyButton.fadeOut();
      } else {
        $stickyButton.fadeIn();
      }
    } else {
      if (isButtonVisible()) {
        $stickyButton.fadeIn();
      } else {
        $stickyButton.fadeOut();
      }
    }
  }

  $stickyButton.on('click', function () {
    if ($('body').hasClass('template--page-latest-home-page')) {
      var $target = $('variant-picker[handle="hair-extensions"]');
      if ($target.length) {
        $('html, body').animate({
          scrollTop: $target.offset().top - 100 
        }, 300);
      }
    } else {
      $actualButton.find('.button').trigger('click');

      var $button = $(this);
      var $loader = $button.find('.custom-button__loader');

      $button.find('.atc-text').fadeOut(200, function () {
        $loader.css('opacity', '1'); 
        $loader.removeClass('hidden');
      });

      setTimeout(function () {
        $loader.css('opacity', '0'); 
        $loader.addClass('hidden');
        $button.find('.atc-text').fadeIn(200); 
      }, 3000);
    }
  });

  $(window).on('scroll resize load', function () {
    toggleStickyButton();
  });

  toggleStickyButton();
});
$(document).ready(function () {
const checkboxIds = ["add-to-cart-checkbox", "add-to-cart-checkbox-shipping"];
const cartDrawer = $("#cart-drawer");

function handleCheckbox(checkboxId) {
  const checkbox = $(`#${checkboxId}`);
  const lineId = checkbox.data("line-id");

  if (!localStorage.getItem(`unchecked-${checkboxId}`) && !checkbox.prop("checked")) {
    console.log(`Checking checkbox (${checkboxId}) and updating cart`);
    checkbox.prop("checked", true);
    updateCart(lineId, 1);
  }
}

if (cartDrawer.length > 0) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === "childList" &&
        cartDrawer.find(".cart-drawer__line-items").length > 0
      ) {
        checkboxIds.forEach((checkboxId) => {
        const checkbox = $(`#${checkboxId}`);
      
        if (checkbox.length === 1) {
          if (checkboxId === "add-to-cart-checkbox" && cartDrawer.hasClass("comb-checkbox-test-running")) {
            console.log(`Checkbox (${checkboxId}) added to DOM and cart drawer updated`);
            handleCheckbox(checkboxId);
          } else if (checkboxId === "add-to-cart-checkbox-shipping" && cartDrawer.hasClass("shipping-precheck-test-running")) {
            console.log(`Checkbox (${checkboxId}) added to DOM and cart drawer updated`);
            handleCheckbox(checkboxId);
          }
        }
      });
       checkCartAndClearIfOnlyShippingProtection();
      }
    }
  });

  observer.observe(cartDrawer[0], { childList: true, subtree: true });
}

$(document).on('change', checkboxIds.map(id => `#${id}`).join(","), function() {
  const checkboxId = $(this).attr("id");
  console.log(`Handling change event for: ${checkboxId}`);

  const isChecked = $(this).is(":checked");
  if (isChecked) {
    $(this).attr("checked", "checked");
  } else {
    $(this).removeAttr("checked");
  }

  const quantity = isChecked ? 1 : 0;

  if (!isChecked) {
    localStorage.setItem(`unchecked-${checkboxId}`, true);
  } else {
    localStorage.removeItem(`unchecked-${checkboxId}`);
  }

  updateCart($(this).data("line-id"), quantity);
});


function updateCart(lineId, quantity) {
  console.log("Updating cart, quantity:", quantity);
  $("cart-drawer.cart-drawer").addClass("cart_loading");

  const updates = {};
  updates[lineId] = quantity;

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then((dataResponse) => {
      let itemCount = dataResponse.item_count;

      setTimeout(() => {
        $countBubble.text(itemCount);
      }, 2500);

      if (isCart()) {
        location.reload();
      } else {
        document.dispatchEvent(new Event("cart:refresh", { bubbles: true }));
        const shippingCheckboxIds = ["add-to-cart-checkbox-shipping"];
        handleCheckbox(shippingCheckboxIds);
        $("cart-drawer.cart-drawer").removeClass("cart_loading");
      }
      checkCartAndClearIfOnlyShippingProtection(dataResponse.items);
    })
    .catch((error) => {
      console.error("Error:", error);
      $("cart-drawer.cart-drawer").removeClass("cart_loading");
    });
}

    function checkCartAndClearIfOnlyShippingProtection(cartItems) {
    // Get the current cart items
    if (!cartItems) {
      fetch(window.Shopify.routes.root + "cart.js")
        .then((response) => response.json())
        .then((cartData) => {
          validateCart(cartData.items);
        });
    } else {
      validateCart(cartItems);
    }
  }

  function validateCart(items) {
  const shippingProtectionId = 44807373226145;
  if (items.length === 1 && items[0].id === shippingProtectionId) {
    console.log("Only Shipping Protection in cart. Clearing cart.");
    clearCart();
  }
    
  }

  function clearCart() {
    fetch(window.Shopify.routes.root + "cart/clear.js", {
      method: "POST",
    })
      .then(() => {
        console.log("Cart cleared");
        location.reload();
      })
      .catch((error) => {
        console.error("Error clearing cart:", error);
      });
  }


$(document).on('click', '.delete-shipping-line-item', function () {
    let checkboxId = 'add-to-cart-checkbox-shipping';
    localStorage.setItem(`unchecked-${checkboxId}`, true);
    console.log(`Shipping checkbox (${checkboxId}) marked as unchecked in localStorage`);
});

});

document.addEventListener("line-item:change", function (event) {
  var cart = event.detail.cart; 
    setTimeout(function() { 
       updateCartCount(cart);
    }, 500);
});

document.addEventListener('variant:add', function(event) {
  var cart = event.detail.cart; 
    setTimeout(function() { 
       updateCartCount(cart);
    }, 500);
});

function updateCartCount(cart) {
    let adjustedItemCount = cart.item_count;

    cart.items.forEach(function (item) {
        if (item.product_title.includes('Shipping Insurance')) {
            adjustedItemCount -= item.quantity;
        }
    });

    const countBubbleElement = document.querySelector('.count-bubble--js');
    if (countBubbleElement) {
        countBubbleElement.textContent = adjustedItemCount;
    }
}


$(document).ready(function() {
    $.get('/cart.js', function(cartData) {
        
        let cart = JSON.parse(cartData);

        
        if (cart.items && Array.isArray(cart.items)) {
            if (cart.items.length === 1 && cart.items[0].price === 0) {
                customClearCart();
                location.reload();
            }

            if (cart.items.length === 2) {
                let freeItem = cart.items.find(item => item.price === 0);
                let paidItem = cart.items.find(item => item.price > 0);
                if (freeItem && paidItem && paidItem.price < 50) {
                    customClearCart();
                }
            }
        } else {
            console.error("cart.items is undefined or not an array");
        }
    });

    function customClearCart() {
        $.post('/cart/clear.js', function() {
            console.log("Cart cleared.");
        });
    }
});



// document.addEventListener('DOMContentLoaded', function () {
//   const carousel = document.querySelector('media-carousel');
//   const dotsWrapper = document.querySelector('.dots-wrapper');
//   const dots = document.querySelectorAll('.dot');
//   const leftArrow = document.querySelector('.arrow--icon-media.left');
//   const rightArrow = document.querySelector('.arrow--icon-media.right');

//   if (!carousel || dots.length === 0) return;

//   function updateDots(index) {
//     dots.forEach((dot, i) => {
//       if (i === index) {
//         dot.setAttribute('aria-current', 'true');
//         dot.scrollIntoView({
//           behavior: 'smooth',
//           inline: 'center',
//           block: 'nearest',
//         });
//       } else {
//         dot.setAttribute('aria-current', 'false');
//       }
//     });
//   }

//   // Sync dots when slide changes
//   carousel.addEventListener('carousel:settle', (event) => {
//     const slideEl = event.detail.slide;
//     const index = Array.from(carousel.items).indexOf(slideEl);
//     if (index !== -1) {
//       updateDots(index);
//     }
//   });

//   updateDots(0);

//   if (!carousel || !leftArrow || !rightArrow) return;

//   leftArrow.addEventListener('click', () => {
//     carousel.previous?.();
//   });

//   rightArrow.addEventListener('click', () => {
//     carousel.next?.();
//   });
// });





document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('media-carousel');
  if (!carousel) return;

  const leftArrow = document.querySelector('.arrow--icon-media.left');
  const rightArrow = document.querySelector('.arrow--icon-media.right');
  const dotsContainer = document.querySelector('page-dots'); // the <page-dots> element

  if (!dotsContainer) console.warn('page-dots element not found');

  // --- Patch: disable theme's scroll-to-variant ---
  if (typeof carousel.select === 'function') {
    const originalSelect = carousel.select;
    carousel.select = function (index, opts) {
      // Ignore Shopify's variant-change jumps
      if (opts && opts.scrollToVariant) return;
      return originalSelect.apply(this, arguments);
    };
  }

  // dynamically query current dots (instead of a one-time NodeList)
  const getDots = () => (dotsContainer ? Array.from(dotsContainer.querySelectorAll('.dot')) : []);

function updateDots(index) {
  const dots = getDots();
  if (!dots.length) return;

  const dotsContainer = document.querySelector('page-dots'); // scrollable container
  if (!dotsContainer) return;

  dots.forEach((dot, i) => {
    dot.setAttribute('aria-current', i === index ? 'true' : 'false');

    if (i === index) {
      const dotRect = dot.getBoundingClientRect();
      const containerRect = dotsContainer.getBoundingClientRect();

      // Calculate scroll distance so active dot is centered
      const offset =
        dotRect.left -
        containerRect.left -
        dotsContainer.clientWidth / 2 +
        dot.clientWidth / 2;

      dotsContainer.scrollBy({
        left: offset,
        behavior: 'smooth',
      });
    }
  });
}

  function rebuildDots() {
    if (!dotsContainer) return;
    dotsContainer.innerHTML = ''; // Clear existing dots

    const allSlides = carousel.querySelectorAll('.imageContainer.product-gallery__media');

    allSlides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'dot tap-area';
      dot.setAttribute('type', 'button');
      dot.setAttribute('aria-current', i === 0 ? 'true' : 'false');

      const span = document.createElement('span');
      span.className = 'sr-only';
      span.textContent = `Go to item ${i + 1}`;

      dot.appendChild(span);

      dot.addEventListener('click', () => {
        if (typeof carousel.select === 'function') {
          carousel.select(i);
        } else {
          const targetSlide = carousel.querySelectorAll('.imageContainer.product-gallery__media')[i];
          targetSlide && targetSlide.scrollIntoView({ behavior: 'smooth', inline: 'center' });
        }
        updateDots(i);
      });

      dotsContainer.appendChild(dot);
    });

    // Try to find currently selected slide so dots reflect current state
    const selectedIndex = (() => {
      const items = carousel.items ? Array.from(carousel.items) : Array.from(allSlides);
      const idx = items.findIndex(it => it && it.classList && it.classList.contains('is-selected'));
      return idx !== -1 ? idx : 0;
    })();

    requestAnimationFrame(() => updateDots(selectedIndex));
  }

  function updateGallery(variantId) {
    carousel.style.transition = 'opacity 0.3s ease';
    carousel.style.opacity = '0';

    setTimeout(() => {
      // Remove only dynamic variant slides
      carousel.querySelectorAll('.variant-slide').forEach(el => el.remove());

      // Clear previous selected class
      carousel.querySelectorAll('.is-selected').forEach(slide => {
        slide.classList.remove('is-selected');
      });

      // Add new slides if available (kept your original reverse+prepend logic)
      if (window.variantImages && window.variantImages[variantId]) {
        window.variantImages[variantId]
          .slice()
          .reverse()
          .forEach((url, index) => {
            const slide = document.createElement('div');
            slide.className = 'imageContainer product-gallery__media snap-center variant-slide';
            slide.setAttribute('data-media-type', 'image');
            slide.setAttribute('data-media-id', `variant-${variantId}-${index + 1}`);
            slide.innerHTML = `<img src="${url}" alt="" loading="lazy">`;

            if (index === window.variantImages[variantId].length - 1) {
              slide.classList.add('is-selected');
            }

            carousel.prepend(slide);
          });
      }

      setTimeout(() => {
        if (typeof carousel.select === 'function') {
          carousel.select(0, { behavior: 'auto' });
        } else {
          carousel.scrollTo({ left: 0, behavior: 'auto' });
        }
      }, 50);

      // Rebuild dots after DOM insertion — requestAnimationFrame ensures DOM is painted
      requestAnimationFrame(() => rebuildDots());

      setTimeout(() => {
        carousel.style.opacity = '1';
      }, 30);
    }, 200);
  }

  carousel.addEventListener('carousel:settle', (event) => {
    const slideEl = event.detail?.slide;
    if (!slideEl) return;
    // Prefer carousel.items if available, otherwise fallback to querying slides
    const items = carousel.items ? Array.from(carousel.items) : Array.from(carousel.querySelectorAll('.imageContainer.product-gallery__media'));
    const index = items.indexOf(slideEl);
    if (index !== -1) updateDots(index);
  });

  if (leftArrow) leftArrow.addEventListener('click', () => carousel.previous?.());
  if (rightArrow) rightArrow.addEventListener('click', () => carousel.next?.());

  let previousVariant = null;

  document.addEventListener('variant:change', (event) => {
    const variant = event.detail?.variant;
    if (!variant?.id) return;

    if (window.variantImages && (!previousVariant || previousVariant.option1 !== variant.option1)) {
      updateGallery(variant.id);
    }

    previousVariant = variant;
  });

  // initial build
  rebuildDots();

  
  if (window.MutationObserver && carousel) {
    const mo = new MutationObserver((mutations) => {
      if (mutations.some(m => m.addedNodes.length || m.removedNodes.length)) {
        rebuildDots();
      }
    });
    mo.observe(carousel, { childList: true, subtree: true });
  }
});

  

const sliders = document.querySelectorAll('.variant-picker__option-values');

sliders.forEach((slider) => {
  let isDown = false;
  let startX = 0;
  let scrollLeft = 0;
  let hasDragged = false;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    hasDragged = false;
    startX = e.pageX;
    scrollLeft = slider.scrollLeft;
    slider.classList.add('active');
  });

  slider.addEventListener('mouseleave', () => {
    if (isDown) {
      isDown = false;
      slider.classList.remove('active');
    }
  });

  slider.addEventListener('mouseup', (e) => {
    if (isDown) {
      isDown = false;
      slider.classList.remove('active');
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX;
    const walk = (x - startX) * 1.5;
    if (Math.abs(walk) > 5) hasDragged = true;
    slider.scrollLeft = scrollLeft - walk;
  });
});


function normalize(str) {
  return str.trim().toLowerCase();
}

    
document.querySelectorAll('.length-option').forEach(button => {
  button.addEventListener('click', function () {
    const selectedColorInput = document.querySelector('.variant-picker__option-values input[name="option1"]:checked');
    if (!selectedColorInput) return;

    document.querySelectorAll('.length-option').forEach(el => el.classList.remove('selected'));
    button.classList.add('selected');

    const pickerContainer = document.querySelector('.variant-picker__option-values-length');
    if (pickerContainer) {
      pickerContainer.classList.add('pdp2-variant-selected');
    }

    const lengthTextElement = button.querySelector('.swatch-label-text');
    const variantLength = lengthTextElement ? lengthTextElement.textContent.trim() : '';

    let variantTitle = selectedColorInput.value + ' / ' + variantLength;
    variantTitle = variantTitle.replace("+ 1 FREE HALO ", "").replace("+ FREE HALO ", ""); 

     var wavyOption = $('.js-freeGiftImage.wavy-Image-Js option').filter(function () {
    return $(this).text().trim() === variantTitle.trim();
  });

  let wavy = wavyOption.data("image");
  $(".wavy--product img").attr("src", wavy);
  console.log(wavy)


    const option = $('.js-freeGiftSelect option').filter(function () {
      return $(this).text().trim() === variantTitle.trim();
    });


    if (option.length) {
     
      option.prop("selected", true);

      const straight = option.data("image");
      if (straight) {
        $(".Free--straight--product img").attr("src", straight);
      }

      const giftVId = option.data("variantid");
      if (giftVId) {
        $productFormCustom.find("input.gift-value--js").val(giftVId);
      }
    } else {
      console.log("❌ Free gift option not found");
    }

    // Get matching variant
    const selectedColor = normalize(selectedColorInput.value);
    if (!selectedColor || !window.pdp2Variants) return;

    const matchedVariant = window.pdp2Variants.find(v =>
      normalize(v.option1) === selectedColor &&
      normalize(v.option2) === normalize(variantLength)
    );

    if (!matchedVariant) return;

    setTimeout(() => {
      const input = document.querySelector('.js-product-form--custom input[name="id"]');
      if (input) input.value = matchedVariant.id;
    }, 100);

  });
});




document.querySelectorAll('.variant-picker__option-values input[name="option2"]').forEach(input => {
  if (!input.closest('.length-option')) {
    input.addEventListener('click', function () {
      document.querySelectorAll('.length-option.selected').forEach(el => {
        el.classList.remove('selected');
      });


      const pickerContainer = document.querySelector('.variant-picker__option-values-length');
      if (pickerContainer && pickerContainer.classList.contains('pdp2-variant-selected')) {
        pickerContainer.classList.remove('pdp2-variant-selected');
      }

    });
  }
});



document.querySelectorAll('.variant-picker__option-values input[name="option1"]').forEach(input => {
  input.addEventListener('change', function () {
    const selectedColor = normalize(this.value.trim());
    const lengthOptions = document.querySelectorAll('.length-option');

    let selectedLength = '';
    let selectedLengthInput = null;


    lengthOptions.forEach(option => {
      if (option.classList.contains('selected')) {
        const lengthLabel = option.querySelector('.swatch-label-text');
        selectedLength = lengthLabel ? normalize(lengthLabel.textContent.trim()) : '';

        
      }
    });

    if (selectedColor && selectedLength && window.pdp2Variants?.length) {
      const matchedVariant = window.pdp2Variants.find(v =>
        normalize(v.option1) === selectedColor &&
        normalize(v.option2) === selectedLength
      );

      if (matchedVariant) { 
        setTimeout(() => {
          const input = document.querySelector('.js-product-form--custom input[name="id"]');
          if (input) input.value = matchedVariant.id;
        }, 100);

        
      } else {
        console.log("❌ No matching variant found for selected color and length");
      }
    } else {
      console.log("ℹ️ No length option selected, or missing variant data");
    }
  });
});


  $(document).on("click", ".custom.product-atc-popup-btn", function (e) {
    e.preventDefault();
    console.log("Click BUY BUTTON");

    var $body = $("body");
    var $popup = $(".upsell-popup");

    $popup.addClass("active");
    $body.addClass("popup_active");
    $("input.product-popup").prop("disabled", false);
  });


 $(document).on(
    "click",
    ".product-atc-popup .product__submit__add",
    async function (e) {
      e.preventDefault();
      console.log("Click On the 'product__submit__add");
      const btn = this;
      const popup = document.querySelector(".upsell-popup");
      const body = document.body;

      btn.setAttribute("aria-busy", "true");

      const redirectToCheckout = () => {
        if (popup) popup.classList.remove("active");
        body.classList.remove("popup_active");
        btn.classList.remove("is-loading");
         $("button.buy-now-btn").removeAttr('aria-busy');
        // Redirect immediately
        window.location.href = "/checkout";
      };

      const addFormProductToCart = async () => {
  const form = $(".js-product-form--custom")[0];
  if (!form) throw new Error("No form found for product submission.");

  const formData = new FormData(form);
  const payload = { items: [] };

  const setItem = (i, field, value) => {
    if (!payload.items[i]) payload.items[i] = {};
    if (field.startsWith("properties[")) {
      const key = field.slice(11, -1);
      (payload.items[i].properties ||= {})[key] = value;
    } else {
      payload.items[i][field] = field === "quantity" ? parseInt(value) || 1 : value;
    }
  };

  for (const [key, value] of formData.entries()) {
    let m = key.match(/^items\[(\d+)]\[(.+)\]$/);
    if (m) setItem(+m[1], m[2], value);
    else if (key === "id" || key === "quantity" || key === "selling_plan" || key.startsWith("properties["))
      setItem(0, key, value);
  }

  payload.items = payload.items.filter(i => i?.id);

  const res = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("Failed to add product to cart.");
  console.log("Products added to cart.");
};


      try {
        await addFormProductToCart();
        redirectToCheckout();
      } catch (error) {
        console.error("Error during product submission or redirect:", error);
        btn.removeAttribute("aria-busy");
      }
    }
  );

    $(document).on(
    "click",
    ".upsell-popup__close, .upsell-popup__decline",
    function (e) {
      e.preventDefault();
      console.log(
        "Click On the 'upsell-popup__close, .upsell-popup__decline' BUTTON"
      );

      var $body = $("body");
      var $popup = $(".upsell-popup");
      var $buyNowBtn = $("button.buy-now-btn");

      $popup.removeClass("active");
      $body.removeClass("popup_active");

      $("input.product-popup").prop("disabled", true);

      const $submitBtn = $(this).closest($popup).find(".product__submit__add");
      if (!$submitBtn.hasClass("clicked")) {
        $submitBtn.addClass("clicked").trigger("click");
        setTimeout(() => $submitBtn.removeClass("clicked"), 2000);
      }

      $buyNowBtn.attr("aria-busy", "true");
    }
  );


 window.addEventListener("pageshow", (event) => {
    const isBackNav = event.persisted || performance.getEntriesByType("navigation")[0]?.type === "back_forward";

    if (!isBackNav) return;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        
        document.querySelectorAll('[data-cart-count], .count-bubble--js')
          .forEach(el => {
            el.textContent = cart.item_count;
          });


        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      })
      .catch(console.error);
  });


  $(document).ready(function(){
  initCartDrawerRecommendationsSlider();
});



function initCartDrawerRecommendationsSlider() {
const $slider = $('.new-product-cart-drawer .cart-drawer__recommendations .horizontal-product-list-carousel .custom_product_upsell_slide');

if ($slider.length && !$slider.hasClass('slick-initialized')) {
  $slider.slick({
    infinite: false,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: `
      <button type="button" class="slick-prev custom-arrow">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 9">
          <path d="M7.16309 5.09045C7.43923 5.09045 7.66309 4.8666 7.66309 4.59045C7.66309 4.31431 7.43923 4.09045 7.16309 4.09045L7.16309 5.09045ZM0.483361 4.2369C0.288098 4.43216 0.288098 4.74874 0.483361 4.94401L3.66534 8.12599C3.8606 8.32125 4.17719 8.32125 4.37245 8.12599C4.56771 7.93073 4.56771 7.61414 4.37245 7.41888L1.54402 4.59045L4.37245 1.76203C4.56771 1.56676 4.56771 1.25018 4.37245 1.05492C4.17719 0.859658 3.8606 0.859658 3.66534 1.05492L0.483361 4.2369ZM7.16309 4.59045L7.16309 4.09045L0.836914 4.09045L0.836914 4.59045L0.836914 5.09045L7.16309 5.09045L7.16309 4.59045Z" />
        </svg>
      </button>
    `,
    nextArrow: `
      <button type="button" class="slick-next custom-arrow">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 9" style="transform: rotate(180deg);">
          <path d="M7.16309 5.09045C7.43923 5.09045 7.66309 4.8666 7.66309 4.59045C7.66309 4.31431 7.43923 4.09045 7.16309 4.09045L7.16309 5.09045ZM0.483361 4.2369C0.288098 4.43216 0.288098 4.74874 0.483361 4.94401L3.66534 8.12599C3.8606 8.32125 4.17719 8.32125 4.37245 8.12599C4.56771 7.93073 4.56771 7.61414 4.37245 7.41888L1.54402 4.59045L4.37245 1.76203C4.56771 1.56676 4.56771 1.25018 4.37245 1.05492C4.17719 0.859658 3.8606 0.859658 3.66534 1.05492L0.483361 4.2369ZM7.16309 4.59045L7.16309 4.09045L0.836914 4.09045L0.836914 4.59045L0.836914 5.09045L7.16309 5.09045L7.16309 4.59045Z" />
        </svg>
      </button>
    `,
  });

  $slider.find('.slick-prev').hide();

  $slider.on('afterChange', function(event, slick, currentSlide) {
    if (currentSlide === 0) {
      $slider.find('.slick-prev').hide();
    } else {
      $slider.find('.slick-prev').show();
    }
  });
}

}

 $(document).on('click', '.horizontal-product__cta button', function (e) {
    e.preventDefault();

    var $button = $(this);
    var variantId = $button.attr('variant-id');

    if (!variantId) {
      console.error('No variant-id attribute found on button.');
      return;
    }

    $button.attr('aria-busy', 'true');

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: 1
      },
      dataType: 'json',
      success: function (response) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
        if (typeof initCartDrawerRecommendationsSlider === "function") {
        setTimeout(function () {
          initCartDrawerRecommendationsSlider();
        }, 2000);
      }
      },
      error: function (xhr, status, error) {
        console.error('Error adding to cart:', error);
      },
      complete: function () {
        $button.removeAttr('aria-busy');
      }
    });
  });


$(document).on(
  "click",
  ".custom-atc-button-js",
  async function (e) {
    e.preventDefault();
    console.log("Click On the 'custom-atc-button-js");
    const btn = this;

    btn.setAttribute("aria-busy", "true");

const addFormProductToCart = async () => {
  const form = btn.closest("form");
  if (!form) throw new Error("No form found for product submission.");

  const formData = new FormData(form);

  const payload = { items: [] };

  const mainId = formData.get("id");
  const mainQuantity = parseInt(formData.get("quantity")) || 1;
  const mainSellingPlan = formData.get("selling_plan");

  const mainItem = {
    id: mainId,
    quantity: mainQuantity,
  };

  if (mainSellingPlan) {
    mainItem.selling_plan = mainSellingPlan;
  }

  // ✅ Extract line-item properties
  const properties = {};
  for (const [key, value] of formData.entries()) {
    const match = key.match(/^properties\[(.+)\]$/);
    if (match) {
      const propName = match[1];
      properties[propName] = value;
    }
  }

  if (Object.keys(properties).length > 0) {
    mainItem.properties = properties;
  }

  if (mainId) {
    payload.items.push(mainItem);
  }

  // ✅ Handle any additional items in the form (bundles, multi-add, etc.)
  for (const [key, value] of formData.entries()) {
    const match = key.match(/^items\[(\d+)]\[(id|quantity|selling_plan)]$/);
    if (match) {
      const index = parseInt(match[1]);
      const field = match[2];

      if (!payload.items[index]) {
        payload.items[index] = {};
      }

      if (field === "quantity") {
        payload.items[index][field] = parseInt(value);
      } else {
        payload.items[index][field] = value;
      }
    }
  }

  payload.items = payload.items.filter((item) => item && item.id);

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error("Failed to add product to cart.");
  }

  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", { bubbles: true })
  );

  setTimeout(() => {
  const openCartTrigger = document.querySelector('a[aria-controls="cart-drawer"]');
  if (openCartTrigger) {
    openCartTrigger.click();
  }
}, 600);

  if (typeof initCartDrawerRecommendationsSlider === "function") {
    setTimeout(function () {
      initCartDrawerRecommendationsSlider();
    }, 2000);
  }

  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      document
        .querySelectorAll("[data-cart-count], .count-bubble--js")
        .forEach((el) => {
          el.textContent = cart.item_count;
        });
    });

  btn.removeAttribute("aria-busy");
  console.log("Products added to cart.");
};

    try {
      await addFormProductToCart();
      // redirectToCheckout();
    } catch (error) {
      console.error("Error during product submission or redirect:", error);
      btn.removeAttribute("aria-busy");
      btn.classList.remove("is-loading");
    }
  }
);


  $(document).ready(function () {
  function handleUpsellCheckbox($checkbox) {
    console.log("working")
    var productId = $checkbox.data('product-id');
    var $form = $('form.js-product-form--custom');

    if (!productId || !$form.length) return;

    $form.find('.upsell-value--js').remove();

    if ($checkbox.is(':checked')) {
      $form.append(
        '<input type="hidden" name="items[2][id]" value="' + productId + '" class="upsell-value--js" required>' +
        '<input type="hidden" name="items[2][quantity]" value="1" class="upsell-value--js" required>'
      );
    }
  }

  $(document).on('change', '.custom-checkbox input[type="checkbox"]', function () {
    handleUpsellCheckbox($(this));
  });

  $('.custom-checkbox input[type="checkbox"]:checked').each(function () {
    handleUpsellCheckbox($(this));
  });
});

function formatVariantText(handle) {
  return handle
    .split('-')                     
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');          
}

const COLOR_TAB_MAP = {
  blonde: [
    "platinum-blonde", "light-champagne", "cream-blonde", "sunny-blonde",
    "pale-ash-blonde", "beach-blonde", "ivory-blonde", "bahama-beige",
    "sahara-beige", "light-ash-blonde", "honey-blonde", "light-honey-blonde",
    "dirty-blonde", "sandy-blonde", "golden-blonde", "sand", "dark-sand",
    "sandy-brunette", "ash-blonde", "brown-blonde",
    "brown-to-cool-blonde", "brown-to-ash-blonde"
  ],

  brown: [
    "brown-to-golden", "dark-brown-to-ash-blonde", "coffee-brown",
    "chestnut", "chocolate", "dark-brown-with-blonde-highlight",
    "light-brown", "medium-brown", "walnut-brown", "chestnut-brown",
    "dark-brown", "mochachino-brown"
  ],

  red: [
    "tizian-red", "golden-auburn", "light-auburn", "red-vino",
    "copper-red", "wine-red", "black-to-wine-red-ombre", "dark-auburn"
  ],

  black: ["off-black", "jet-black"],

  grey: ["silver-light-grey", "dark-grey"]
};

function getTabFromVariant(variant) {
  if (!variant) return null;

  const v = variant.toLowerCase();

  for (const [tab, list] of Object.entries(COLOR_TAB_MAP)) {
    if (list.includes(v)) {
      return tab;
    }
  }

  return null;
}


$(document).ready(function () {

  let variant = getCookie('variantName');
  const hairLength = getCookie('hairLength');

  if (!variant) return;

  // Normalize variant:
  // 1. lowercase
  // 2. remove -straight / -wavy + everything after
  variant = variant
    .toLowerCase()
    .replace(/-(straight|wavy).*$/i, "")
    .trim();

  const tab = getTabFromVariant(variant);
  if (!tab) return;

  const tabSelector = `.color-option-js[data-tab-name="${tab}"]`;
  const variantSelector = `.variant-picker__option-values [data-category="${variant}"]`;
  const hairSelector = `.variant-picker__option-values [data-value="${(hairLength || '').toLowerCase()}"]`;

  setTimeout(() => {

    $(tabSelector).trigger("click");
    $(variantSelector).trigger("click");

    if (hairLength) {
      $(hairSelector).trigger("click");
    }

    $(".variant-picker__option")
      .find("variant-option-value")
      .html(formatVariantText(variant));

  }, 500);

  setTimeout(() => {
    deleteCookie('variantName');
    deleteCookie('hairLength');
  }, 1500);

});


  $(document).ready(function () {

    // Collection page tab
    $('.collection_tab_heading').click(function () {
  var $this = $(this);
  var dataTab = $this.data('tab');
  var $wrapper = $('.collection_tab_content_wrapper');
  var $activeCollection = $wrapper.find(`#${dataTab}`);

  $this.addClass('active').siblings().removeClass('active');
  $activeCollection.addClass('active').siblings().removeClass('active');

  $('html, body').animate({ scrollTop: 0 }, 400);

  initProductImageSlider($activeCollection);
});


    // Collection page Product poupup
    $('.custom-product-popup-btn').click(function () {
      // initProductImageSlider();
      $(this).addClass('active');
      $('body').css('overflow', 'hidden');
      $(this).siblings('.custom-product-popup, .custom-overlay').addClass('active');
      
       setTimeout(() => {
    initProductImageSlider();
  }, 100);
    });
    $('.custom-poup-close').click(function () {
      $(this).removeClass('active');
      $('body').css('overflow', 'unset');
      $('.custom-product-popup-btn, .custom-product-popup, .custom-overlay').removeClass('active');
    });

    $('.swatch-image-wrapper').click(function () {
      $(this).addClass('active');
      $(this).siblings().removeClass('active');
      const select_hairsize = $(this).data("value");
      $(this).closest('.product-card__info').find('.custom-redirection-btn.mob_btn').attr('data-hair-length', select_hairsize);
    });
    initProductImageSlider();
  });

function initProductImageSlider($collection) {
  var $sliders;

  if ($collection && $collection.length) {
    $sliders = $collection.find(".product_image_slider");
  } else {
    $sliders = $(".product_image_slider");
  }

  $sliders.each(function () {
    var $slider = $(this);

    if ($slider.hasClass("slick-initialized")) {
      $slider.slick("setPosition");
    } else {
      $slider.slick({
        slidesToShow: 1,
        infinite: true,
        slidesToScroll: 1,
        arrows: true,
        dots: true
      });
    }
  });
}

  var $defaultActive = $('.collection_tab_content_wrapper .collection.active');
  initProductImageSlider($defaultActive);

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("scroll-carousel").forEach((carousel) => {

    const dotsWrapper = carousel.parentElement.querySelector("page-dots");
    if (!dotsWrapper) return;

    const dots = Array.from(dotsWrapper.querySelectorAll("button"));
    const items = Array.from(carousel.querySelectorAll(".text-with-icons__item"));

    if (!dots.length || !items.length) return;

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        const target = items[index];
        if (!target) return;

        target.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest"
        });

        setActiveDot(index);
      });
    });

    let scrollTimeout;

    carousel.addEventListener("scroll", () => {
      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(() => {
        const carouselRect = carousel.getBoundingClientRect();

        let closestIndex = 0;
        let closestDistance = Infinity;

        items.forEach((item, index) => {
          const rect = item.getBoundingClientRect();
          const distance = Math.abs(rect.left - carouselRect.left);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        setActiveDot(closestIndex);
      }, 80);
    });

    function setActiveDot(activeIndex) {
      dots.forEach((dot, i) => {
        dot.setAttribute("aria-current", i === activeIndex ? "true" : "false");
      });
    }

  });
});
